import type { CXScheduleContainerBlock } from '~/components/ClientExperience/OneFlow/models/cx-schedule-container-block.model';
import { CXScheduleController } from '~/components/ClientExperience/OneFlow/controllers/cx-schedule.controller';
import { TFullTimezone } from '~/utils/timezone.utils';
import { getLeadFormSessionStorageMethods } from '~/components/CXLeadForm/leadFormSessionStorage.utils';
import { IScheduleContainerVariableValue } from '~/types/server.types';

export class PublicCXScheduleController extends CXScheduleController {
    async selectSlot(
        block: CXScheduleContainerBlock,
        selectedDate: string,
        timezone: TFullTimezone
    ) {
        const { sessionConfig, flow_id, connected_variable_id } = block;

        const { setVariable } = getLeadFormSessionStorageMethods({
            flowId: flow_id
        });

        const variableToStore: IScheduleContainerVariableValue = {
            date_time_start: selectedDate,
            client_timezone: timezone,
            client: {
                _id: undefined,
                full_name: undefined,
                email: undefined
            },
            session_name: sessionConfig.session_name,
            session_type: sessionConfig.session_type,
            session_duration: sessionConfig.session_duration,
            meeting_location: sessionConfig.meeting_location,
            session_description: sessionConfig.session_description
        };

        block.setTempVariableValue(variableToStore);

        setVariable({
            variableId: connected_variable_id,
            value: variableToStore
        });
    }
}
